import { IHttpService, ILogService, IPromise, IQService } from 'angular';
import { Subscription } from 'rxjs';

import { Configuration } from '@contact/upgrade';

import { IChatDiscussion } from './models/chat-discussion';

const MODULE_NAME = 'chatService';

export interface IChatService {
  getChatDiscussions(discussionUuid: string): IPromise<IChatDiscussion>;
}

export class ChatService implements IChatService {
  static $inject: Array<string> = ['$log', '$q', '$http', 'configuration'];
  public name = MODULE_NAME;
  private haveOpenSubscription: Subscription;
  private DISCUSSIONS_URL = '/discussion/';

  constructor(
    protected readonly $log: ILogService,
    private readonly $q: IQService,
    private readonly $http: IHttpService,
    private readonly configuration: Configuration
  ) {}

  getChatDiscussions(discussionUuid: string): IPromise<IChatDiscussion> {
    let deferred = this.$q.defer<any>();
    this.$http.get(this.getBaseUrl() + this.DISCUSSIONS_URL + discussionUuid + '/light').then(
      success => {
        if (success.data) {
          deferred.resolve(success.data);
        } else {
          deferred.reject();
        }
      },
      () => {
        deferred.reject();
      }
    );

    return deferred.promise;
  }

  getBaseUrl(): string {
    return this.configuration.chat?.chatBaseUrl + '/api';
  }

  $onDestroy() {
    this.haveOpenSubscription.unsubscribe();
  }
}

export default MODULE_NAME;
